var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 4884 3348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4596.9,3347.01c-0,0 406.906,-558.573 250.656,-1179.84c-73.313,-291.412 -191.469,-828.626 -1340.97,-828.626c-507.781,-0 -522.5,-1339.35 -1811.99,-1339.35c-1927.26,-0 -2106.35,2759.61 -1063.19,3347.81l3965.49,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.234,
    y: -0.807,
    width: 4883.51,
    height: 3492.07,
    style: {
      fill: "#f6f6f6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-152.815,2136.36c0,-0 1125.74,-1079.4 5445.15,348.725l0,861.923l-5445.15,0l0,-1210.65Z",
    style: {
      fill: "#ededed",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4036.84,2329.27c0,310.632 -251.812,562.449 -562.437,562.449c-310.656,0 -562.469,-251.817 -562.469,-562.449c0,-310.63 251.813,-562.479 562.469,-562.479c310.625,-0 562.437,251.849 562.437,562.479Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1968.93,2825.4c0,0 1797.78,-743.546 5548.75,521.604l-5548.75,0l0,-521.604Z",
    style: {
      fill: "#c6c6c6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2943.28,867.704c-126.313,-0 -255.656,-3.119 -387.656,-9.366c-287.3,-13.597 -587.547,-41.963 -892.394,-84.308c-519.072,-72.105 -876.41,-161.019 -879.96,-161.906c-7.715,-1.935 -12.406,-9.76 -10.468,-17.479c1.934,-7.716 9.762,-12.409 17.478,-10.472c3.534,0.887 359.678,89.489 877.315,161.372c477.513,66.314 1194.03,131.55 1895.78,65.761c7.906,-0.738 14.937,5.081 15.687,13.003c0.75,7.922 -5.094,14.944 -13,15.688c-196.875,18.456 -405.281,27.707 -622.781,27.707Z",
    style: {
      fill: "#c6c6c6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030.42,1086.82l0,847.372c0,193.817 -157.696,351.538 -351.509,351.538l-166.269,0l0,905.737c0,90.22 -73.125,163.347 -163.34,163.347c-90.219,-0 -163.344,-73.127 -163.344,-163.347l-0,-1596.11l-185.425,-0c-193.813,-0 -351.509,-157.7 -351.509,-351.517l-0,-157.018c-0,-90.221 73.125,-163.347 163.34,-163.347c90.219,-0 163.344,73.126 163.344,163.347l-0,157.018c-0,13.669 11.131,24.826 24.825,24.826l185.425,-0l-0,-560.596c-0,-90.22 73.125,-163.347 163.344,-163.347c90.215,0 163.34,73.127 163.34,163.347l0,1250.97l166.269,-0c13.694,-0 24.828,-11.157 24.828,-24.845l0,-847.372c0,-90.221 73.125,-163.347 163.341,-163.347c90.19,-0 163.34,73.126 163.34,163.347Z",
    style: {
      fill: "#9d9d9c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.84,1225.85c-13.9,0 -25.168,-11.269 -25.168,-25.169l-0,-237.314c-0,-13.903 11.268,-25.172 25.168,-25.172c13.9,-0 25.169,11.269 25.169,25.172l0,237.314c0,13.9 -11.269,25.169 -25.169,25.169Z",
    style: {
      fill: "#878787",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.55,2040.86c-13.9,-0 -25.169,-11.25 -25.169,-25.157l-0,-237.317c-0,-13.907 11.269,-25.157 25.169,-25.157c13.9,0 25.168,11.25 25.168,25.157l0,237.317c0,13.907 -11.268,25.157 -25.168,25.157Z",
    style: {
      fill: "#878787",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.49,1753.22c-13.9,0 -25.168,-11.281 -25.168,-25.188l-0,-237.304c-0,-13.901 11.268,-25.17 25.168,-25.17c13.904,0 25.172,11.269 25.172,25.17l0,237.304c0,13.907 -11.268,25.188 -25.172,25.188Z",
    style: {
      fill: "#878787",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.279,1369.68c-13.9,-0 -25.169,-11.269 -25.169,-25.169l0,-237.315c0,-13.9 11.269,-25.169 25.169,-25.169c13.9,0 25.169,11.269 25.169,25.169l-0,237.315c-0,13.9 -11.269,25.169 -25.169,25.169Z",
    style: {
      fill: "#878787",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.59,1490.74l0,104.621l-50.337,-0l-0,-104.621c-0,-13.901 11.266,-25.166 25.169,-25.166c6.953,-0 13.25,2.821 17.797,7.372c4.546,4.546 7.371,10.844 7.371,17.794Z",
    style: {
      fill: "#878787",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-78.834,2825.4c0,0 1934.42,-743.546 5970.45,521.604l-5970.45,0l0,-521.604Z",
    style: {
      fill: "#878787",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4660.24,1397.78l-0,417.511c-0,101.189 -73.157,185.66 -169.375,203.191c-9.657,1.75 -19.5,2.813 -29.563,3.188c-2.5,0.094 -5.031,0.125 -7.562,0.125l-97.657,-0l0,772.89c0,53.001 -42.937,95.971 -95.937,95.971c-53,-0 -95.969,-42.97 -95.969,-95.971l0,-584.199l-108.906,0c-113.875,0 -206.5,-92.627 -206.5,-206.504l-0,-266.849c-0,-52.97 42.968,-95.946 95.937,-95.946c53,0 95.969,42.976 95.969,95.946l0,266.849c0,8.063 6.531,14.594 14.594,14.594l108.906,-0l0,-682.76c0,-53.001 42.969,-95.958 95.969,-95.958c53,-0 95.937,42.957 95.937,95.958l0,494.069l97.657,-0c8.062,-0 14.593,-6.532 14.593,-14.594l0,-417.511c0,-53.002 42.969,-95.959 95.969,-95.959c53,0 95.938,42.957 95.938,95.959Z",
    style: {
      fill: "#c6c6c6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4490.87,1964.57l-0,53.907c-9.657,1.75 -19.5,2.813 -29.563,3.188l-0,-57.095c-0,-8.188 6.625,-14.782 14.782,-14.782c4.093,0 7.781,1.657 10.437,4.313c2.687,2.688 4.344,6.375 4.344,10.469Z",
    style: {
      fill: "#b2b2b2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4269.31,1530.14c-8.187,-0 -14.781,-6.619 -14.781,-14.788l-0,-139.406c-0,-8.166 6.594,-14.788 14.781,-14.788c8.156,0 14.781,6.622 14.781,14.788l0,139.406c0,8.169 -6.625,14.788 -14.781,14.788Z",
    style: {
      fill: "#b2b2b2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4254.53,1908.23c-8.188,0 -14.813,-6.594 -14.813,-14.781l0,-139.409c0,-8.157 6.625,-14.782 14.813,-14.782c8.156,-0 14.781,6.625 14.781,14.782l0,139.409c0,8.187 -6.625,14.781 -14.781,14.781Z",
    style: {
      fill: "#b2b2b2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4580.49,1639.98c-8.156,0 -14.781,-6.619 -14.781,-14.785l0,-139.408c0,-8.166 6.625,-14.785 14.781,-14.785c8.157,-0 14.782,6.619 14.782,14.785l-0,139.408c-0,8.166 -6.625,14.785 -14.782,14.785Z",
    style: {
      fill: "#b2b2b2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3923.28,1967.38c-8.156,0 -14.781,-6.625 -14.781,-14.781l-0,-139.409c-0,-8.188 6.625,-14.782 14.781,-14.782c8.156,0 14.781,6.594 14.781,14.782l0,139.409c0,8.156 -6.625,14.781 -14.781,14.781Z",
    style: {
      fill: "#b2b2b2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2985.24,1136.41c-30.875,-0 -62.094,-0.122 -93.75,-0.372c-7.969,-0.062 -14.375,-6.566 -14.313,-14.519c0.063,-7.919 6.5,-14.297 14.406,-14.297l0.126,-0c437.249,3.456 787.312,-15.91 1070.09,-59.151c399.625,-61.114 641.344,-168.641 718.438,-319.6c64.406,-126.068 65.937,-269.271 4.093,-383.064c-46.062,-84.755 -147.406,-190.579 -368.593,-213.429c-7.907,-0.819 -13.657,-7.897 -12.844,-15.813c0.812,-7.919 7.938,-13.666 15.812,-12.851c95.313,9.851 178.125,36.004 246.125,77.739c62.688,38.479 111.407,89.146 144.813,150.591c66.375,122.152 64.968,275.396 -3.719,409.933c-133.875,262.093 -712.656,394.833 -1720.69,394.833Z",
    style: {
      fill: "#c6c6c6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2636.24,1131.11c-0.157,-0 -0.313,-0 -0.469,-0.007c-161.406,-4.95 -265.672,-11.715 -266.706,-11.784c-7.938,-0.519 -13.954,-7.375 -13.432,-15.316c0.519,-7.938 7.4,-13.957 15.316,-13.435c1.031,0.069 104.822,6.804 265.728,11.735c7.938,0.244 14.188,6.888 13.938,14.841c-0.219,7.803 -6.625,13.966 -14.375,13.966Z",
    style: {
      fill: "#c6c6c6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2946.96,867.504c-505.343,-0 -980.459,-49.879 -1330.66,-100.096c-7.875,-1.131 -13.347,-8.431 -12.219,-16.307c1.131,-7.878 8.441,-13.338 16.309,-12.219c489.7,70.227 1224.29,139.797 1942.98,72.424c7.906,-0.738 14.937,5.081 15.687,13.003c0.75,7.919 -5.094,14.944 -13,15.688c-207.156,19.416 -415.594,27.507 -619.094,27.507Z",
    style: {
      fill: "#c6c6c6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2194.68,2658.18c0,0 -88.094,-184.441 0,-246.723c0,-0 -17.619,122.221 39.641,246.723c-0,0 -11.01,-212.129 79.284,-287.068c0,0 11.013,178.691 -50.653,287.068c-0,0 74.881,-267.474 169.581,-322.787c0,-0 -50.653,265.161 -125.534,322.787c-0,0 202.619,-136.034 198.212,-195.972c0,-0 17.625,89.908 -154.165,204.035c-0,-0 140.947,-53.032 233.447,-145.253c-0,0 -75.813,130.284 -166.744,161.409c-0,0 -88.728,36.876 -223.069,-24.219Z",
    style: {
      fill: "#878787",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.576,2738.46c-0,-0 -88.094,-184.472 -0,-246.723c-0,-0 -17.619,122.189 39.64,246.723c0,-0 -11.009,-212.129 79.288,-287.068c-0,-0 11.009,178.691 -50.653,287.068c-0,-0 74.878,-267.474 169.578,-322.819c-0,0 -50.653,265.162 -125.534,322.819c-0,-0 202.615,-136.065 198.212,-196.004c0,0 17.619,89.939 -154.166,204.067c0,-0 140.95,-53.032 233.45,-145.253c0,-0 -75.818,130.252 -166.746,161.378c-0,0 -88.725,36.907 -223.069,-24.188Z",
    style: {
      fill: "#878787",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3550.09,2645.34c0,0 -80.437,-98.002 -36.656,-148.565c0,-0 7.531,76.22 60.5,142.659c0,-0 -38.125,-126.065 5.125,-184.597c0,-0 33.156,105.939 12.125,180.347c0,-0 5.375,-172.16 54.156,-219.536c0,0 8.876,167.191 -27.625,213.004c0,0 101.781,-112.002 90.219,-147.44c0,0 23.969,51.532 -62.5,145.753c0,-0 76.969,-52.845 118.969,-122.127c-0,-0 -26.281,89.689 -76.406,121.939c-0,0 -47.969,35.376 -137.907,18.563Z",
    style: {
      fill: "#c6c6c6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2279.64,590.773c-0,0 132.14,0.634 173.259,-37.541c41.094,-38.173 -96.913,-21.826 -173.259,37.541Z",
    style: {
      fill: "#878787",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4070.81,882.385c0,0 132.125,0.635 173.25,-37.541c41.094,-38.173 -96.906,-21.826 -173.25,37.541Z",
    style: {
      fill: "#c6c6c6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3474.4,1441.8c-0,-0 106.875,77.692 162.531,70.713c55.688,-6.978 -65.906,-74.314 -162.531,-70.713Z",
    style: {
      fill: "#c6c6c6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4070.81,102.995c0,-0 -218.812,-93.73 -313.781,-59.229c-94.969,34.504 145.469,104.173 313.781,59.229Z",
    style: {
      fill: "#878787",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesert);
export default __webpack_public_path__ + "static/media/Desert.63fa1f7d15905d5a482da691e64c5a23.svg";
export { ForwardRef as ReactComponent };